import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../../strings/i18n';
import { FAS_CIRCLE_EXCLAMATION } from '../../../../../const/icon-props';
import { TextWrapper } from '../subcomponents';
import StatusMessage from '../StatusMessageBox';
const ExpiredMembershipMessageBox = () => {
    return (_jsx(StatusMessage, { iconTitle: "exclamation circle icon", type: "warning", icon: FAS_CIRCLE_EXCLAMATION, messageTitle: translate('expiredMembership.title'), messageDescription: _jsx(TextWrapper, { children: translate('expiredMembership.subtitle') }) }));
};
export default ExpiredMembershipMessageBox;
